import * as React from "react";
const SvgFiRrLettuce = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lettuce_svg__a)">
      <path
        fill="#062147"
        d="M23.566 9.8a4 4 0 0 0-4.973-5.526 4.67 4.67 0 0 0-2.4-1.2.65.65 0 0 1-.421-.409 4 4 0 0 0-7.542 0 .67.67 0 0 1-.4.4 4.7 4.7 0 0 0-2.421 1.2A4 4 0 0 0 .434 9.8 1.53 1.53 0 0 1 .4 11.062a4.97 4.97 0 0 0 1.315 5.682q.15.12.285.256a5.02 5.02 0 0 0 7.11 4.524c3.376 3.326 2.412 3.311 5.78 0A5.012 5.012 0 0 0 22 17c.019-.029.295-.252.295-.252a4.97 4.97 0 0 0 1.305-5.686 1.53 1.53 0 0 1-.034-1.262M7 20a3 3 0 0 1-3-3 2.17 2.17 0 0 0-.975-1.764A2.93 2.93 0 0 1 2 13c.15-1.407 1.03-2.8.213-4.114a2 2 0 0 1 2.043-2.86 4.43 4.43 0 0 0 .757 4.3 1.28 1.28 0 0 1 .219 1.186A5.03 5.03 0 0 0 7 17c0 1.02.315 2.014.9 2.848A3 3 0 0 1 7 20m8-3a3 3 0 0 1-2 2.816V9a1 1 0 1 0-2 0v10.816A3 3 0 0 1 9 17a2.4 2.4 0 0 0-.975-1.764 2.94 2.94 0 0 1-.888-3.113 3.25 3.25 0 0 0-.578-3.064 2.46 2.46 0 0 1-.531-1.942A2.55 2.55 0 0 1 8.174 5.04a2.64 2.64 0 0 0 1.939-1.7 2 2 0 0 1 3.774 0 2.65 2.65 0 0 0 1.942 1.706 2.54 2.54 0 0 1 2.143 2.076 2.46 2.46 0 0 1-.531 1.942C16.393 10.193 16.773 11.646 17 13a2.94 2.94 0 0 1-1.03 2.241A2.4 2.4 0 0 0 15 17m5.909-1.71a2.1 2.1 0 0 0-.91 1.71 3 3 0 0 1-3.891 2.851 4.83 4.83 0 0 0 .883-2.79 5.19 5.19 0 0 0 1.777-5.547 1.28 1.28 0 0 1 .219-1.186 4.43 4.43 0 0 0 .757-4.3 2 2 0 0 1 2.042 2.861C20.97 10.2 21.85 11.592 22 13a2.97 2.97 0 0 1-1.091 2.29"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lettuce_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLettuce;
